import React, { Component, PropTypes } from 'react';
import { Colors } from 'Css';
import FormFieldContainer from './FormFieldContainer';
import AspectRatioContainer from 'components/AspectRatioContainer';
import * as SvgIcons from 'components/Material/SvgIcons';
import UploadDialog from 'components/MediaLibrary/UploadDialog';

const css = oxygenCss({
  videoContainer: {
    textAlign: 'center',
    cursor: 'pointer',
    borderStyle: 'solid',
    borderWidth: 2,
    borderColor: '#535353',
    position: 'absolute',
    display: 'flex',
    alignItems: 'stretch',
    '&hasImage': {
      borderColor: Colors.creen
    }
  },
  wrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
});

const styles = {
  icon: {
    width: 64,
    height: 64
  },
  addIcon: {
    position: 'absolute',
    right: -12,
    bottom: -12
  }
};

class VideoChooser extends Component {
  static propTypes = {
    title: PropTypes.string,
    onChange: PropTypes.func
  };

  static contextTypes = {
    getIntlMessage: PropTypes.func
  };

  state = {
    uploadDialog: false
  };

  openDialog = () => {
    this.setState({ uploadDialog: true });
  };

  closeDialog = () => {
    this.setState({ uploadDialog: false });
  };

  changeImage = src => {
    const { onChange } = this.props;
    onChange && onChange(src);
    this.closeDialog();
  };

  render() {
    const { title } = this.props;
    const { uploadDialog } = this.state;
    const { getIntlMessage } = this.context;
    return (
      <FormFieldContainer title={title}>
        <AspectRatioContainer
          mediaClassName={css.videoContainer}
          onTouchTap={this.openDialog}
        >
          <div className={css.wrapper}>
            <SvgIcons.AvMovie style={styles.icon} color={'#535353'} />
            <SvgIcons.ContentAddCircleOutline
              color={Colors.creen}
              style={styles.addIcon}
            />
          </div>
        </AspectRatioContainer>
        <UploadDialog
          onRequestClose={this.closeDialog}
          onSuccess={this.changeImage}
          title={getIntlMessage('video.upload')}
          description={getIntlMessage('module.dropVideo')}
          type="video"
          open={uploadDialog}
        />
      </FormFieldContainer>
    );
  }
}

export default VideoChooser;



// WEBPACK FOOTER //
// ./src/js/components/Store/Editor/VideoChooser.js